<template>
  <div>
    <head-reservation-supervisor @click-save-btn="saveReservation" :reservation="r"></head-reservation-supervisor>
    <div class="container-fluid">
      <b-alert v-if="errors" v-model="showErrors" dismissible variant="danger" class="alert-fixed-bottom">
        <ul class="m-0">
          <template v-for="field in errors">
            <li v-for="(m, index) in field" :key="index" class="text-danger">{{ m }}</li>
          </template>
        </ul>
      </b-alert>
      <b-alert v-model="updateSuccess" dismissible variant="success" class="alert-fixed-bottom">
        La reservación se actualizo correctamente
      </b-alert>
      <div class="row">
        <div class="col-md-8">
          <ValidationObserver ref="form">
            <b-form>
              <Loading :active="loading" :full-page="true"></Loading>
              <b-card header-tag="header" footer-tag="footer">
                <template #header>
                  <h6 class="mb-0 d-flex">
                    <div>
                      Datos de la reservacion
                    </div>
                    <strong class="ml-auto">
                      ${{ r.total }}{{ r.currency }}
                    </strong>
                  </h6>
                </template>
                <b-card-text text-tag="div">
                  <div class="row">
                    <div class="col-md-4">
                      <b-input-group prepend="Folio" class="mb-2 mr-sm-2 mb-sm-0">
                        <b-form-input id="inline-form-input-folio" v-model="r.folio" placeholder="Folio"></b-form-input>
                      </b-input-group>
                    </div>
                    <div class="col-md-4">
                      <ValidationProvider name="Nombre" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-1"
                          description="Cliente"
                          label-for="input-1"
                        >
                          <b-form-input id="input-1" v-model="r.customer_name" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                      <b-form-group class="ml-auto" v-slot="{ ariaDescribedby }">
                        <ValidationProvider name="Zona" rules="required" v-slot="{ validated, valid, errors }" class="ml-auto">
                          <b-form-radio-group
                            id="radio-group-1"
                            v-model="r.service_zone"
                            :options="serviceAreas"
                            :aria-describedby="ariaDescribedby"
                            name="radio-options"
                          ></b-form-radio-group>
                          <span class="text-danger">{{errors[0]}}</span>
                        </ValidationProvider>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4 custom-autocomplete">
                      <label for="" class="d-block">Placa</label>
                      <autocomplete
                        class=""
                        :search="searchVehicles"
                        placeholder="Placa"
                        aria-label="Placa"
                        :default-value="r.vehicle_licence_plate ? r.vehicle_licence_plate : ''"
                        :get-result-value="getResultValueVehicle"
                        @submit="onSelectVehicle"
                      ></autocomplete>
                    </div>
                    <div class="col-md-4">
                      <ValidationProvider name="Producto" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-2"
                          description="Tipo de vehiculo"
                          label="Producto"
                          label-for="input-2"
                        >
                          <b-form-input id="input-2" v-model="r.service_name" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                      <ValidationProvider name="Servicio" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-3"
                          description="Tipo de servicio"
                          label="Servicio"
                          label-for="input-3"
                        >
                          <!-- <b-form-input id="input-3" v-model="r.service_type"  trim></b-form-input> -->
                          <b-form-select id="select-3" v-model="r.service_type" :state="getState(validated, valid)" :options="typesServices"></b-form-select>
                        </b-form-group>
                        </ValidationProvider>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group
                        id="input-group-from-hotel"
                        label="Desde"
                        label-for="fromHotel"
                        :class="getClassState(stateFromHotel)"
                      >
                        <hotel-autocomplete
                          :default-hotel.sync="fromHotel"
                          id="fromHotel"
                          :state="stateFromHotel"
                          @on-select-hotel="onSelectFromHotel"
                          @on-search="onSearchFromHotel"
                        ></hotel-autocomplete>
                        <small
                          v-if="stateFromHotel === false"
                          tabindex="-1"
                          id="input-group-from__BV_description_"
                          class="form-text text-danger"
                        >
                          Seleccione un hotel del listado
                        </small>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group
                        id="input-group-to-hotel"
                        label="Hacia"
                        label-for="toHotel"
                        :class="getClassState(stateToHotel)"
                      >
                        <hotel-autocomplete
                          :default-hotel.sync="toHotel"
                          id="toHotel"
                          :state="stateToHotel"
                          @on-select-hotel="onSelectToHotel"
                          @on-search="onSearchToHotel"
                        ></hotel-autocomplete>
                        <small
                          v-if="stateToHotel === false"
                          tabindex="-1"
                          id="input-group-to__BV_description_"
                          class="form-text text-danger"
                        >
                          Seleccione un hotel del listado
                        </small>
                      </b-form-group>
                    </div>
                    <div class="col-md-2">
                      <ValidationProvider name="Pax" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-6"
                          label="Pax"
                          label-for="input-6"
                        >
                          <b-form-input id="input-6" v-model="r.pax" type="number" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-2">
                      <ValidationProvider name="Pax" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-terminal"
                          label="Terminal"
                          label-for="input-terminal"
                        >
                          <!-- <b-form-input id="input-terminal" v-model="r.pax" type="number" :state="getState(validated, valid)" trim></b-form-input> -->
                          <b-form-select id="select-terminal" v-model="r.terminal" :state="getState(validated, valid)" :options="terminals"></b-form-select>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                  </div>
                  <b-form-group
                    id="fieldset-address"
                    label="Dirección"
                    label-for="address"
                  >
                    <b-form-input id="address" v-model="reservation.address" ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="fieldset-special_request"
                    label="Observaciones"
                    label-for="special_request"
                  >
                    <b-form-input id="special_request" v-model="reservation.special_request"></b-form-input>
                  </b-form-group>
                  <hr>
                  <div class="row">
                    <div class="col-md-4">
                      <ValidationProvider name="Email" rules="required|email" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-13"
                          description=""
                          label="Email"
                          label-for="input-13"
                        >
                          <b-form-input id="input-13" v-model="r.contact_email" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-6">
                      <b-form-group
                        id="fieldset-14"
                        description=""
                        label="Tel"
                        label-for="input-14"
                      >
                        <MazPhoneNumberInput
                          v-model="r.contact_phone"
                          placeholder="#Tel"
                          :default-country-code="r.contact_country"
                          @update="phone = $event"
                        />
                      </b-form-group>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-md-4">
                      <ValidationProvider name="Total" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-16"
                          description=""
                          label="Total"
                          label-for="input-16"
                        >
                          <b-form-input id="input-16" disabled v-model="r.total" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                      <ValidationProvider name="Moneda" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-17"
                          description=""
                          label="Moneda"
                          label-for="input-17"
                        >
                          <b-form-select id="select-17" disabled v-model="r.currency" :state="getState(validated, valid)" :options="currencies"></b-form-select>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                  </div>
                </b-card-text>
              </b-card>
              <b-card v-if="r.service_type == 'arrival' || r.service_type == 'round trip'" class="mt-3" header-tag="header">
                <template #header>
                  <h6 class="mb-0">
                    <strong class="">
                      LLegada
                    </strong>
                  </h6>
                </template>
                <b-card-text text-tag="div">
                  <div class="row">
                    <div class="col-md-3">
                      <ValidationProvider name="Fecha de llegada" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-7"
                          description=""
                          label="Fecha"
                          label-for="arrival-date"
                        >
                          <b-form-datepicker
                            id="arrival-date"
                            v-model="arrivalDate"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
                            :state="getState(validated, valid)"
                            class="mb-2"></b-form-datepicker>
                          <!-- <b-form-input id="input-7" :value="$moment(r.arrival_date).format('DD MMM YYYY HH:mm')"  trim></b-form-input> -->
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider name="Hora de llegada" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-arrival-time"
                          description=""
                          label="Hora"
                          label-for="arrival-time"
                        >
                          <b-form-timepicker v-model="arrivalTime" :state="getState(validated, valid)" ></b-form-timepicker>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <!-- <ValidationProvider name="Aerolinea de llegada" rules="required" v-slot="{ validated, valid }"> -->
                        <b-form-group
                          id="fieldset-8"
                          description=""
                          label="Aerolinea"
                          label-for="input-8"
                          class="airline-autocomplete"
                        >
                          <autocomplete
                            :search="searchAirlines"
                            placeholder="Aerolinea"
                            aria-label="Aerolinea"
                            :get-result-value="getResultValue"
                            :default-value="r.arrival_airline"
                            @submit="onSelectArrivalAirline"
                          ></autocomplete>
                          <!-- <b-form-input id="input-8" v-model="r.arrival_airline" :state="getState(validated, valid)" trim></b-form-input> -->
                        </b-form-group>
                      <!-- </ValidationProvider> -->
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider name="Vuelo de llegada" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-9"
                          description=""
                          label="#Vuelo"
                          label-for="input-9"
                        >
                          <b-form-input id="input-9" v-model="r.arrival_flight" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                  </div>
                </b-card-text>
              </b-card>
              <b-card v-if="r.service_type == 'departure' || r.service_type == 'round trip'" class="mt-3" header-tag="header">
                <template #header>
                  <h6 class="mb-0">
                    <strong class="">
                      Salida
                    </strong>
                  </h6>
                </template>
                <b-card-text text-tag="div">
                  <div class="row">
                    <div class="col-md-3">
                      <ValidationProvider name="Fecha de salida" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-departure-date"
                          description=""
                          label="Fecha"
                          label-for="departure-date"
                        >
                          <b-form-datepicker
                            id="departure-date"
                            v-model="departureDate"
                            :state="getState(validated, valid)"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
                            class="mb-2"></b-form-datepicker>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider name="Hora de salida" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-departure-time"
                          description=""
                          label="Hora"
                          label-for="departure-time"
                        >
                          <b-form-timepicker id="departure-time" v-model="departureTime" :state="getState(validated, valid)"></b-form-timepicker>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <!-- <ValidationProvider name="Aerolinea de salida" rules="required" v-slot="{ validated, valid }"> -->
                        <b-form-group
                          id="fieldset-11"
                          description=""
                          label="Aerolinea"
                          label-for="input-11"
                          class="airline-autocomplete"
                        >
                          <autocomplete
                            :search="searchAirlines"
                            placeholder="Aerolinea"
                            aria-label="Aerolinea"
                            :get-result-value="getResultValue"
                            :default-value="r.departure_airline"
                            @submit="onSelectDepartureAirline"
                          ></autocomplete>
                          <!-- <b-form-input id="input-11" v-model="r.departure_airline" :state="getState(validated, valid)" trim></b-form-input> -->
                        </b-form-group>
                      <!-- </ValidationProvider> -->
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider name="Vuelo de salida" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-12"
                          description=""
                          label="#Vuelo"
                          label-for="input-12"
                        >
                          <b-form-input id="input-12" v-model="r.departure_flight" :state="getState(validated, valid)" trim></b-form-input>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-3">
                      <ValidationProvider name="Hora de pickup" rules="required" v-slot="{ validated, valid }">
                        <b-form-group
                          id="fieldset-pickup-time"
                          description=""
                          label="Hora pickup"
                          label-for="pickup-time"
                        >
                          <b-form-timepicker id="pickup-time" v-model="pickupTime" :state="getState(validated, valid)"></b-form-timepicker>
                        </b-form-group>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-4">
                      <div id="fieldset-pickup-date" role="group" class="form-group">
                        <label for="pickup-date" style="color:#212529 !important">
                          <b-form-checkbox
                          id="checkbox-1"
                          v-model="showPickupDate"
                          name="checkbox-1"
                        >
                          Editar fecha de pickup
                        </b-form-checkbox>
                        </label>
                        <div v-if="showPickupDate">
                          <ValidationProvider name="Nombre" rules="required" v-slot="{ validated, valid }">
                            <b-form-datepicker
                              id="pickup-date"
                              v-model="pickupDate"
                              :state="getState(validated, valid)"
                              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
                              class="mb-2"></b-form-datepicker>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card>
              <b-button class="mt-3" @click="save" variant="primary">Guardar</b-button>
            </b-form>
          </ValidationObserver>
        </div>
        <div class="col-md-4">
          <reservation-history :reservation="reservation" :update="updateHistory"></reservation-history>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
  import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
  import { required, email } from 'vee-validate/dist/rules'
  extend('email', email)
  extend('required', required)
  import {NumberFormat} from "../../helpers/NumberFormat"
  export default {
    name:'ReservationSupervisor',
    components:{ValidationObserver, ValidationProvider},
    props:{
      reservation: {
        required:true,
        type: Object
      },
      airlines:{
        required:true,
        type: Array
      },
    },
    data() {
      const pickupDate = this.reservation.pickup_time
        ? this.$moment(this.reservation.pickup_time).format('YYYY-MM-DD')
        : this.$moment(this.reservation.departure_date).format('YYYY-MM-DD')
      const pickupTime = this.reservation.pickup_time
      ? this.$moment(this.reservation.pickup_time).format('HH:mm:ss')
      : ''
      const showPickupDate = pickupDate !== this.$moment(this.reservation.departure_date).format('YYYY-MM-DD')
      return {
        typesServices: [
          { value: 'arrival', text: 'LLegada' },
          { value: 'round trip', text: 'Redondo' },
        ],
        currencies: [
          { value: 'USD', text: 'USD' },
          { value: 'MXN', text: 'MXN' },
        ],
        serviceAreas:[
          { text: 'Local', value: 'local' },
          { text: 'Foraneo', value: 'foreign' },
        ],
        updateHistory: false,
        showErrors: false,
        loading: false,
        stateToHotel: null,
        stateFromHotel: null,
        phone: null,
        updateSuccess: null,
        errors: null,
        fromHotel: {
          id: this.reservation.from_hotel_id,
          value: this.reservation.from_hotel
        },
        arrivalDate: this.$moment(this.reservation.arrival_date).format('YYYY-MM-DD'),
        arrivalTime: this.$moment(this.reservation.arrival_date).format('HH:mm:ss'),
        departureDate: this.$moment(this.reservation.departure_date).format('YYYY-MM-DD'),
        departureTime: this.$moment(this.reservation.departure_date).format('HH:mm:ss'),
        showPickupDate,
        pickupDate,
        pickupTime,
        toHotel: {
          id: this.reservation.to_hotel_id,
          value: this.reservation.to_hotel
        },
        terminals: ['T2', 'T3', 'T4'],
        r: this.reservation
      }
    },
    mounted() {
      this.r.total = this.numberFormat(this.r.total)
    },
    methods:{
      onSelectDepartureAirline(result) {
        this.r.departure_airline = result.name
      },
      onSelectArrivalAirline(result) {
        this.r.arrival_airline = result.name
      },
      searchAirlines(input) {
        if (input.length < 1) { return [] }
          return this.airlines.filter(airline => {
            return airline.name.toLowerCase()
              .indexOf(input.toLowerCase()) > -1
          })
      },
      getResultValue(result) {
        return result.name
      },
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 2, ',', '.')
      },
      getClassState(state) {
        if (state === null) {
          return ''
        }
        if (state) {
          return 'valid'
        } else {
          return 'is-invalid'
        }
      },
      onSelectFromHotel(data) {
        this.r.from_hotel_id = data.id
        this.r.from_hotel = data.value
        this.r.from_destination = data.destination
        this.r.from_destination_id = data.destination_id
        this.validHotels()
      },
      onSelectToHotel(data) {
        this.r.to_hotel_id = data.id
        this.r.to_hotel = data.value
        this.r.to_destination = data.destination
        this.r.to_destination_id = data.destination_id
        this.validHotels()
      },
      getState(validated, valid) {
        if (!validated) {
          return null;
        }
        return valid
      },
      save() {
        this.saveReservation({})
      },
      onSearchFromHotel() {
        this.r.from_hotel_id = ''
      },
      onSearchToHotel() {
        this.r.to_hotel_id = ''
      },
      validHotels() {
        this.stateToHotel = this.r.to_hotel_id ? true : false
        this.stateFromHotel = this.r.from_hotel_id ? true : false
        return this.stateToHotel && this.stateFromHotel
      },
      getDataReservation() {
        let r = {...this.r}
        r.contact_phone = this.phone.nationalNumber
        r.contact_country = this.phone.countryCode
        r.arrival_date = this.arrivalDate + ' ' + this.arrivalTime
        if (this.r.service_type == 'round trip') {
          r.departure_date = this.departureDate + ' ' + this.departureTime
          r.pickup_time = this.pickupDate + ' ' + this.pickupTime
        }
        return r
      },
      saveReservation() {
        if (this.validHotels()) {
          this.updateSuccess = null
          this.$refs.form.validate().then((success) => {
            if (success) {
              const r = this.getDataReservation()

              this.loading = true
              this.showErrors = false
              const url = `${process.env.MIX_APP_URL}${this.$prefixPanel}/reservations/${r.id}/update`
              this.$axios.post(url, r).then(rs => {
                this.updateSuccess = true
                this.updateHistory = !this.updateHistory
                this.loading = false
              })
              .catch(error=> {
                this.showErrors = true
                if (error.response) {
                  this.errors = error.response.data.errors
                }  else {
                  this.errors = {
                    unexpected: ['Hubo un error por favor contacte al administrador']
                  }
                }
                console.log('error update', error);
                this.loading = false
              })
            }
          })
        }
      },
      getResultValueVehicle(result) {
        return result.licence_plate
      },
      searchVehicles(input) {
        this.$emit('on-search', {input : input})
        return new Promise(resolve => {
          const url = `${process.env.MIX_APP_URL}/api-feraltar/search-vehicles?q=${encodeURI(input)}&terminal=${this.reservation.terminal}`
          if (input.length < 3) {
            return resolve([])
          }
          this.$axios.get(url).then(rs => {
            // console.log('data.data', rs.data);
            resolve(rs.data.vehicles)
          })
          .catch(error=> {
            console.log('error search vehicles', error);
          })
        })
      },
      onSelectVehicle(result) {
        this.r.vehicle_id = result.id
      },
    }
  }
</script>